import "./ClientAuthStyles.css";
import { useState } from "react";
import ClientsQueries from "../../../../requests/queries/ClientsQueries";
import LoadingSpinner from "../../../common/Loading";
import { useParams } from "react-router-dom";

const PasswordForget = () => {

  const { token } = useParams();

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const email = event.target.email.value;
    const res = await ClientsQueries.resetPassword(email);
    if(res.status === 200) {
      setSuccess(res.data.message);
      setError(null);
      setIsLoading(false);
    } else {
      setSuccess(null);
      setIsLoading(false);
      setError(res.data.message || 'An error occurred');
    }
  }

  const handleSubmitWithToken = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const password = event.target.password.value;
    const res = await ClientsQueries.resetPasswordWithToken(token, password);
    if(res.status === 200) {
      setSuccess(res.data.message);
      setError(null);
      setIsLoading(false);
    } else {
      setSuccess(null);
      setIsLoading(false);
      setError(res.data.message || 'An error occurred');
    }
  }
  
  if(isLoading){
    return <LoadingSpinner />;
  }


  if(token){
    return (
    <div className="auth-container">
        <div className="logo-container">
            <img 
                src="/patricians.png" 
                alt="Patricians Logo" 
                className="logo-image"
            />
        </div>
        <div className="auth-card">
            <h2 className="auth-title">Forgot password</h2>
            <p className="auth-subtitle">Enter your new password</p>
            <form onSubmit={handleSubmitWithToken}>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">New password</label>
                    <input type="password" className="form-control" id="password" name="password" placeholder="Enter your new password" required />
                    <button type="submit" className="btn btn-auth mt-3">Update password</button>
                </div>
                {error && <div className="error-message mt-3 mb-3">{error}</div>}
                {
                    success && 
                    <div className="success-message mt-3 mb-3">{success}
                        <button onClick={() => window.location.href = '/client-auth'} className="btn btn-auth mt-3">Sign in</button>
                    </div>
                }
            </form>
        </div>
    </div>);
  }

  return (
    <div className="auth-container">
      <div className="logo-container">
        <img 
          src="/patricians.png" 
          alt="Patricians Logo" 
          className="logo-image"
        />
      </div>

      <div className="auth-card">
        <h2 className="auth-title">Forgot password</h2>
        <p className="auth-subtitle">Enter your email to receive a password reset link</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email" className="form-control" id="email" name="email" placeholder="Enter your email" required />
          </div>
          <button type="submit" className="btn btn-auth">Send reset link</button>
          {error && <div className="error-message mt-3 mb-3">{error}</div>}
          {success && <div className="success-message mt-3 mb-3">{success}</div>}
        </form>
      </div>
    </div>
  );
}

export default PasswordForget;